module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/servizi/tesseramento/crea-tesseramento/dirigente/crea-tesseramento-dirigente.component.scss
// module id = ./src/app/servizi/tesseramento/crea-tesseramento/dirigente/crea-tesseramento-dirigente.component.scss
// module chunks = main